// extracted by mini-css-extract-plugin
module.exports = {"container":"SuggestionCard_container__2WwIw","head":"SuggestionCard_head__2bk9A","headText":"SuggestionCard_headText__NqcR2"};